import { Navigate, useParams } from "react-router";

import { useGetEntityTemplate } from "@/entities/entity-template";
import { AssetTypeTemplateFormEditor } from "@/modules/asset-type-template/asset-type-template-form-editor";
import { AssetTypeTemplatePageHeader } from "@/modules/asset-type-template/asset-type-template-page-header";
import { isError404 } from "@/services/api";

export const AssetTypeTemplatePage = () => {
  const { id } = useParams();
  const { isLoading, template, error, removeQuery } = useGetEntityTemplate(
    id ?? ""
  );

  if (isError404(error)) {
    removeQuery();
    return <Navigate to="/technical-forms" />;
  }

  return (
    <>
      <AssetTypeTemplatePageHeader template={template} loading={isLoading} />
      <AssetTypeTemplateFormEditor template={template} loading={isLoading} />
    </>
  );
};
